import { createTheme, Divider, Input, Stack, ThemeProvider } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers";

import {AdapterDateFns} from '@mui/x-date-pickers/AdapterDateFns'

import { RouterProvider } from "react-router-dom";
import { router } from "./router/routes";
import { Provider } from "react-redux";
import store from "./store/store";
import { customStyles } from "./styles";

import image from './assets/images/mini-logo.png'
import { animations } from "./utils/animations";
import { CaptionText, SmallText } from "./components/helpers";
import { Footer } from "./components/footer";
function App() {
  const theme = createTheme({
    typography: {
      fontFamily: '\"Lato"\, "Roboto\", \"Helvetica\", \"Arial\", sans-serif'
    }
  })
  return (
    <Provider store={ store }>
      <ThemeProvider theme={ theme }>
        <LocalizationProvider dateAdapter={ AdapterDateFns }>  
        <div className="App" >
          <RouterProvider router={ router }/>
          <Footer />
          {/* <div className={animations.pulse}  style={{ 
          width: '100%',
          height: '100vh',
          backgroundImage: `url(${image})`,
          backgroundRepeat: 'space',
          // height: '100vh',
          position: 'fixed',
          left: 0, top: 0, opacity: .03,
          zIndex: -10,
          animationIterationCount: 'infinite',
          animationDuration: '10s'
          }}></div>  DEPRECRATED */}
          <Stack color={customStyles.colors.textColor} alignItems="center" sx={{ position: 'fixed', right: 10, bottom: 0, 
          // transform: 'translateX(-50%)'
          zIndex: -1000
         }} >
          {/* <SmallText text="(Work in Progress)"/> */}
          {/* <CaptionText text="portal" color={customStyles.colors.textColor} /> */}
          </Stack>
        </div>
        </LocalizationProvider>
      </ThemeProvider>
    </Provider>
  );
}

export default App;

 